import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grain-bg flex min-h-screen items-center justify-center bg-cream p-6" data-testid="page-admin-login">
      <form onSubmit={submit} className="w-full max-w-md border border-border bg-white p-10">
        <div className="section-label">Admin</div>
        <h1 className="mt-3 font-serif text-4xl tracking-tight">Rabbitry login</h1>
        <p className="mt-2 text-sm text-stone">Enter your credentials to manage rabbits and inquiries.</p>
        <div className="mt-8 space-y-5">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-stone">Email</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" className="mt-2 w-full border border-border bg-cream px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-stone">Password</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" className="mt-2 w-full border border-border bg-cream px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta" />
          </div>
          <button disabled={busy} data-testid="admin-login-submit" className="w-full rounded-full bg-terracotta px-8 py-3.5 text-sm text-white transition-transform hover:-translate-y-0.5 disabled:opacity-60">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </div>
      </form>
    </div>
  );
}
